import React from 'react';
import './CustomerStatsCards.css';

const CustomerStatsCards = ({ stats }) => {
  return (
    <div className="customer-stats-cards">
      <div className="stat-card">
        <div className="stat-icon blue">
          <span>👥</span>
        </div>
        <div className="stat-content">
          <div className="stat-number">{stats.total.toLocaleString()}</div>
          <div className="stat-label">Total Customers</div>
          <div className="stat-growth positive">
            <span>↑</span> +12%
          </div>
        </div>
      </div>

      <div className="stat-card">
        <div className="stat-icon green">
          <span>⭐</span>
        </div>
        <div className="stat-content">
          <div className="stat-number">{stats.newThisMonth}</div>
          <div className="stat-label">New This Month</div>
          <div className="stat-growth positive">
            <span>↑</span> +8%
          </div>
        </div>
      </div>

      <div className="stat-card">
        <div className="stat-icon yellow">
          <span>🔥</span>
        </div>
        <div className="stat-content">
          <div className="stat-number">{stats.active}</div>
          <div className="stat-label">Active Customers</div>
          <div className="stat-subtext">Ordered in last 30 days</div>
        </div>
      </div>
    </div>
  );
};

export default CustomerStatsCards;

